import { Inject, Injector, Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions }
  from '@angular/http';
import {IAppConfig} from "../models/app-config.model";
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;
  constructor(private http: Http) {}
  load():Promise<void>{
    const jsonFile = 'assets/config/config.prod.json';
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response ) => {
        AppConfig.settings = <IAppConfig>response.json();
        resolve();

      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  /*  return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response : IAppConfig) => {
        AppConfig.settings = <IAppConfig>response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });*/
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/app.config.ts